import TrainingWizardStepThree, { validator } from './TrainingWizardStepThree'

export { validator }
export default TrainingWizardStepThree
